import { render, staticRenderFns } from "./TherapistDashModalAddSchedule.vue?vue&type=template&id=7112e58b&scoped=true"
import script from "./TherapistDashModalAddSchedule.vue?vue&type=script&lang=js"
export * from "./TherapistDashModalAddSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7112e58b",
  null
  
)

export default component.exports